import { UseFormReturn } from 'react-hook-form'

import { CustomFormQuestion } from 'components/tools/CustomForm/types'

type Params = {
  formMethods: UseFormReturn<any>
  questions: CustomFormQuestion[]
}

export default function setRegistroDeHoraExtra(params: Params) {
  const { questions, formMethods } = params
  const { watch } = formMethods

  const periodo2Visibility = false
  const periodo3Visibility = false
  const periodo4Visibility = false
  const periodo5Visibility = false
  const periodo6Visibility = false

  function isValidDate(date: string) {
    // Verifica o formato dd/mm/yyyy
    const regex = /^\d{2}\/\d{2}\/\d{4}$/
    if (!regex.test(date)) return false

    const [diaStr, mesStr, anoStr] = date.split('/')
    const dia = parseInt(diaStr, 10)
    const mes = parseInt(mesStr, 10)
    const ano = parseInt(anoStr, 10)

    // O JavaScript conta os meses de 0 (jan) a 11 (dez), por isso subtrai 1
    const data = new Date(ano, mes - 1, dia)

    return data.getFullYear() === ano && data.getMonth() === mes - 1 && data.getDate() === dia
  }

  const titleForQuestion = Object.fromEntries(questions.map((q) => [q.title, q.slug]))

  //PERIODO 2
  const periodo2Data = watch(`form_answers.${titleForQuestion['PERÍODO 2 - Data de realização da hora extra']}`)
  //PERIODO 3
  const periodo3Data = watch(`form_answers.${titleForQuestion['PERÍODO 3 - Data de realização da hora extra']}`)
  //PERIODO 4
  const periodo4Data = watch(`form_answers.${titleForQuestion['PERÍODO 4 - Data de realização da hora extra']}`)
  //PERIODO 5
  const periodo5Data = watch(`form_answers.${titleForQuestion['PERÍODO 5 - Data de realização da hora extra']}`)
  //PERIODO 6
  const periodo6Data = watch(`form_answers.${titleForQuestion['PERÍODO 6 - Data de realização da hora extra']}`)

  const filteredQuestions = questions.filter((question) => {
    const questionAboutPeriod = question.title?.includes('PERÍODO')
    const match = question.title?.match(/PERÍODO (\d+) -/)
    let number = null

    if (questionAboutPeriod) {
      if (match) {
        number = parseInt(match[1], 10)
      }
    }

    //PERIODO 1
    if (question.title == 'PERÍODO 1 - Duração') {
      return true
    }

    //PERIODO 2
    if (number == 2 && !periodo2Visibility) {
      return false
    }

    if (number == 2) {
      if (question.title == 'PERÍODO 2 - Data de realização da hora extra') {
        return true
      }
      if (
        question.title == 'PERÍODO 2 - Início da hora extra' ||
        question.title == 'PERÍODO 2 - Fim da hora extra' ||
        question.title == 'PERÍODO 2 - Duração'
      ) {
        if (!isValidDate(periodo2Data)) {
          return false
        }
      }
      if (question.title == 'PERÍODO 2 - Duração') {
        return true
      }
    }

    //PERIODO 3
    if (number == 3 && !periodo3Visibility) {
      return false
    }

    if (number == 3) {
      if (question.title == 'PERÍODO 3 - Data de realização da hora extra') {
        return true
      }
      if (
        question.title == 'PERÍODO 3 - Início da hora extra' ||
        question.title == 'PERÍODO 3 - Fim da hora extra' ||
        question.title == 'PERÍODO 3 - Duração'
      ) {
        if (!isValidDate(periodo3Data)) {
          return false
        }
      }
      if (question.title == 'PERÍODO 3 - Duração') {
        return true
      }
    }

    //PERIODO 4
    if (number == 4 && !periodo4Visibility) {
      return false
    }

    if (number == 4) {
      if (question.title == 'PERÍODO 4 - Data de realização da hora extra') {
        return true
      }
      if (
        question.title == 'PERÍODO 4 - Início da hora extra' ||
        question.title == 'PERÍODO 4 - Fim da hora extra' ||
        question.title == 'PERÍODO 4 - Duração'
      ) {
        if (!isValidDate(periodo4Data)) {
          return false
        }
      }
      if (question.title == 'PERÍODO 4 - Duração') {
        return true
      }
    }

    //PERIODO 5
    if (number == 5 && !periodo5Visibility) {
      return false
    }

    if (number == 5) {
      if (question.title == 'PERÍODO 5 - Data de realização da hora extra') {
        return true
      }
      if (
        question.title == 'PERÍODO 5 - Início da hora extra' ||
        question.title == 'PERÍODO 5 - Fim da hora extra' ||
        question.title == 'PERÍODO 5 - Duração'
      ) {
        if (!isValidDate(periodo5Data)) {
          return false
        }
      }
      if (question.title == 'PERÍODO 5 - Duração') {
        return true
      }
    }

    //PERIODO 6
    if (number == 6 && !periodo6Visibility) {
      return false
    }

    if (number == 6) {
      if (question.title == 'PERÍODO 6 - Data de realização da hora extra') {
        return true
      }
      if (
        question.title == 'PERÍODO 6 - Início da hora extra' ||
        question.title == 'PERÍODO 6 - Fim da hora extra' ||
        question.title == 'PERÍODO 6 - Duração'
      ) {
        if (!isValidDate(periodo6Data)) {
          return false
        }
      }
      if (question.title == 'PERÍODO 6 - Duração') {
        return true
      }
    }

    return true
  })

  return filteredQuestions
}
